import { evaluateCondition, type ConditionExpression } from '../engine/condition-evaluator';
import type { CategoryExecutor } from './executor.types';

export const executeDecisionNode: CategoryExecutor = (node, context, outgoingEdges) => {
  const branches = [...outgoingEdges].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

  const matched = branches.find(
    (edge) =>
      !edge.isDefault &&
      edge.condition != null &&
      evaluateCondition(edge.condition as ConditionExpression, context.payload),
  );
  const chosen = matched ?? branches.find((edge) => edge.isDefault) ?? branches[0];

  if (!chosen) {
    return {
      status: 'failure',
      message: `Decision node "${node.nodeKey}" has no matching branch and no default branch`,
      code: 'NO_BRANCH',
    };
  }

  const config = node.configuration ?? {};
  const outcomeValue =
    typeof config['outcomeValue'] === 'string' ? config['outcomeValue'] : undefined;

  return {
    status: 'success',
    nextEdgeId: chosen.id,
    output: outcomeValue ? { outcomeValue, lastDecision: outcomeValue } : {},
  };
};
